import { sortArrayByObjectKey } from 'Utils'
import { packsSettings } from 'Utils/config/diy'
import accountActions from 'ServicesActions/account'

export const namespaced = true

export const state = () => ({
  clients: null,
})

export const mutations = {
  SET_CLIENTS(state, payload) {
    state.clients = payload
  },
}

export const actions = {
  async load({ commit }) {
    try {
      let clients = await accountActions.get.all()

      // checking for empty pack names or expired dates
      for (const client of clients.data) {
        if (!client.pack_name) client.pack_name = Object.keys(packsSettings)[0]
        if (!client.pack_end_date) client.pack_end_date = '-'
      }

      clients.data = sortArrayByObjectKey(clients.data, 'pack_end_date', true)

      commit('SET_CLIENTS', clients.data)
      return clients
    } catch (error) {
      return error
    }
  },
}

export const getters = {
  getClients: (state) => {
    return state.clients
  },
}
